<template>
    <div class="forward_msg_popup_wrp">
  <div class="forward_msg_popup_center">
    <div class="forward_msg_popup_body">
      <div class="forward_popup_header">
        <h3 class="forward_msg_heading"><i class="fa fa-times mr-3" @click="forwardMsgPopupClosed"></i> Forward message
          to</h3>
        <div class="forward_msg_searchbar">
          <div class="forward_msg_searchbar_new_chat" :class="searchEnabled ? 'search_enabled' : ''">
            <div class="search_for_new_chat_inner">
              <span class="back">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                  @click="searchBarForChatClosedFun">
                  <path fill="#87cefa" d="M12 4l1.4 1.4L7.8 11H20v2H7.8l5.6 5.6L12 20l-8-8 8-8z"></path>
                </svg>
              </span>
              <span class="search">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                  <path fill="#ffffff"
                    d="M15.009 13.805h-.636l-.22-.219a5.184 5.184 0 0 0 1.256-3.386 5.207 5.207 0 1 0-5.207 5.208 5.183 5.183 0 0 0 3.385-1.255l.221.22v.635l4.004 3.999 1.194-1.195-3.997-4.007zm-4.808 0a3.605 3.605 0 1 1 0-7.21 3.605 3.605 0 0 1 0 7.21z">
                  </path>
                </svg>
              </span>
              <input class="form-control" v-model="search_term" placeholder="Search or start new chat"
                @click="searchEnabledMethod">
              <span class="x-alt" v-if="search_term.length > 3 && searchEnabled">
                <img src="@/assets/images/close.svg" class="img-fluid" @click="searchBarForChatClosedFun">
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="forward_popup_body">
        <div class="forward_msg_to_list_wrp">
          <div class="forward_msg_to_list" v-if="fullChatData">
            <div class="forward_msg_to_list_item" v-for="(item, index) in filteredSupportUsers" :key="index">
              <template v-if="item.chat_room != chatRoomInfo.chat_room">
                <label :for="'chat' + item.id">
                  <span class="forward_user_checkbox">
                    <input type="checkbox" :id="'chat' + item.id" :value="item" v-model="forwardMsgToSelctedUserInfo">
                    <span class="checkbox"><i class="fa fa-check"></i></span>
                  </span>
                  <span class="forward_user_avtaar">
                    <span v-if="item.is_group_chat">
                      <img :src="item.group_image" alt="" width="50" v-if="item.group_image">
                      <img src="@/assets/images/user_default.png" alt="" width="50" v-else>
                    </span>
                    <span v-else>
                      <template v-if="item.user">
                        <img :src="item.user.profile.thumbnail" alt="" width="50" v-if="item.user.profile.thumbnail">
                        <img src="@/assets/images/user_default.png" alt="" width="50" v-else>
                      </template>
                    </span>
                  </span>
                  <span class="forward_user_info">
                    <template v-if="item.is_group_chat">
                      <span class="forward_user_name">{{item.name}}</span>
                    </template>
                    <template v-else>
                      <template v-if="item.user">
                        <span class="forward_user_name">{{item.user.first_name}} {{item.user.last_name}}</span>
                        <span class="forward_user_email">{{item.user.email}}</span>
                      </template>
                    </template>
                  </span>
                </label>
              </template>
            </div>
          </div>
        </div>
        <div class="msg_forward_btn_wrp" v-if="forwardMsgToSelctedUserInfo.length > 0">
          <div class="row align-items-center">
            <div class="col-10 pr-0">
              <ul class="msg_forward_to_selcted_wrp">
                <li v-for="item in forwardMsgToSelctedUserInfo" :key="item.id">
                  <template v-if="item.is_group_chat">
                    <span>{{item.name}}</span>
                  </template>
                  <template v-else>
                    <span v-if="item.user"> {{item.user.first_name}} {{item.user.last_name}}</span><i>,</i>
                  </template>
                </li>
              </ul>
            </div>
            <div class="col-2 text-right ml-auto">
              <button class="btn" @click="forwardMsgToSelctedUserMethod" :disabled="submitted">
                <svg viewBox="0 0 24 24" width="24" height="24" class="">
                  <path fill="#ffffff"
                    d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>


<script>
/*eslint-disable */
import {
  bus
} from '@/main';
import {
  mapGetters
} from 'vuex';

const $ = window.jQuery = require('jquery');
export default {
  name: 'support-forward-msg-popup',
  components: {},
  props: ['forwardMsgInfo', 'roomSocketUrl', 'chatRoomInfo'],
  data () {
    return {
      searchEnabled:false,
      search_term:'',
      allUserData:null,
      allUserDataResults:[],
      selfUserId:'',
      forwardMsgToSelctedUserInfo:[],
      forwardMsgToSelctedUserId:[],
      forwardMsgToSelctedChatRoomId:[],
      checkbox:'',
      submitted:false,
      sendNewRoomIdForMsg:'',
      fullChatRoomListResult: [],
    }
  },
  computed: {
    ...mapGetters([
      'userChatListGetters'
    ]),
    fullChatData() {
        return this.$store.getters.userChatListGetters.data;
    },
      // Filtered list based on search_filter
    filteredSupportUsers() {
        if (this.search_term) {
            const lowerCaseFilter = this.search_term.toLowerCase();
            return this.fullChatRoomListResult.filter((item) =>
            item.user.first_name.toLowerCase().startsWith(lowerCaseFilter)
            );
        }
        return this.fullChatRoomListResult;
    },
  },
  mounted () {
    this.selfUserId = localStorage.getItem('LoginedUserID');
    document.body.classList.add('body_right_scroll_remove');
    this.initializeChatData();
  },
  methods: {
    initializeChatData() {
        if (this.fullChatData) {
            this.fullChatRoomListResult = this.fullChatData.results || [];
            this.fullChatListForLoadMore = this.fullChatData.next || '';
        }
    },
    searchEnabledMethod(){
      this.searchEnabled = true;
    },

    searchBarForChatClosedFun(){
      this.searchEnabled = false;
      this.search_term = '';
    },
    
    forwardMsgPopupClosed(){
      bus.$emit('messageSearchPopupStateBus', false);
      document.body.classList.remove('body_right_scroll_remove');
      bus.$emit('forwardMsgPopupBus', false);
    },

    getChatRoomIdsMethod(info){
      this.forwardMsgToSelctedChatRoomId= [];
      info.map((item) => {
        this.forwardMsgToSelctedChatRoomId.push(item.chat_room);
      })
      return  this.forwardMsgToSelctedChatRoomId;
    },
    
    getChatUserIdMethod(info){
      this.forwardMsgToSelctedUserId= [];
      info.map((item) => {
        this.forwardMsgToSelctedUserId.push(item.user.id);
      })
      return this.forwardMsgToSelctedUserId;
    },

    getForwarededMessagesIdsMethod(messages){
      const messageIds = [];
      messages.map((item) => {
        messageIds.push(item.id);
      })
      return  messageIds;
    },

    forwardMsgToSelctedUserMethod() {
      const roomIds = this.getChatRoomIdsMethod(this.forwardMsgToSelctedUserInfo);
      const messageIds = this.getForwarededMessagesIdsMethod(this.forwardMsgInfo);
      if(this.roomSocketUrl){
        this.roomSocketUrl.send(JSON.stringify({
          type: 'forward_message',
          message_id: messageIds,
          new_chat_room_id:roomIds,
        }));
      }
      this.forwardMsgPopupClosed();
      setTimeout(() => {
        this.$store.dispatch('adminChatListFun');
      }, 100);
    }
  },
  watch: {
      fullChatData: {
          handler() {
              this.initializeChatData();
          },
          deep: true,
      },
  }
}
</script>

<style lang="scss" scoped>
.forward_msg_popup_wrp {
    position: fixed;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.92);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    .forward_msg_popup_center {
        height: 100%;
        display: flex;
        width: 100%;
        align-items: center;
    }
    .forward_msg_popup_body{
        background: #000;
        max-width: 400px;
        width:100%;
        margin: 0 auto;
        border-radius: 5px;
        -webkit-box-shadow: 3px 3px 3px rgba(255, 255, 255, 0.05), -3px -3px 3px rgba(255, 255, 255, 0.05);
        box-shadow: 3px 3px 3px rgba(255, 255, 255, 0.05), -3px -3px 3px rgba(255, 255, 255, 0.05);
    }
    .forward_msg_heading {
        background: #232323;
        color: #ffffff;
        padding: 10px 15px;
        margin: 0;
        border-radius: 5px 5px 0px 0px;
        font-size: 22px;
        font-weight:normal;
        .fa{cursor:pointer;&:hover{color: #e4002b;}}
    }
    .forward_msg_to_list_wrp {
        height: 280px;
        overflow-y: auto;
        padding:10px 0;
        &::-webkit-scrollbar {
        width: 4px;
        background: transparent;
        }
        &::-webkit-scrollbar-thumb {
        background-color: #333333;
        }
    }
    .forward_msg_to_list{
        .forward_msg_to_list_item{
            padding:0px 15px;
            .forward_user_checkbox{
                .checkbox{
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    width: 16px;
                    height: 16px;
                    border: 2px solid #ffc107;
                    border-radius: 2px;
                    line-height: 16px;
                    -webkit-box-pack: center;
                    -ms-flex-pack: center;
                    justify-content: center;
                    cursor: pointer;
                    .fa{
                        color: #000000;
                        font-size: 0px;
                    }
                }
                input[type="checkbox"]{
                    visibility:hidden;
                    display: none;
                    &:checked + .checkbox{
                        background-color: #ffc107;
                        border-color: #ffc107;
                        .fa{font-size:14px;line-height:1;}
                    }
                }
            }
        }
        label {
            display: flex;
            align-items: center;
            cursor: pointer;
            margin:0px;
        }
        .forward_user_avtaar {
            padding:5px 10px;
            img{
                width:40px;
                height:40px;
                border-radius: 50%;
            }
        }
        .forward_user_info{
            span{display:block;}
            .forward_user_name{
                line-height: 1;
                font-size: 16px;
                margin-bottom: 3px;
                color: #fff;
            }
            .forward_user_email{
                font-size: 15px;
                color: rgba(255, 255, 255, 0.5);
                white-space: pre-wrap;
                word-break: break-all;
            }
        }
    }
    .forward_msg_searchbar_new_chat {
    padding: 10px;
    background: #1d2226;
    border-bottom: 1px solid #171b1f;
    .search_for_new_chat_inner {
    position: relative;
    background: rgba(255, 255, 255,  0.1);
    border-radius: 80px;
    padding: 0;
    .back {
    display: none;
    position: absolute;
    left:0px;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    cursor:pointer;
    }
    .search {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    }
    .x-alt {
    position: absolute;
    right:15px;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    cursor:pointer;
    .img-fluid {
    width: 15px;
    }
    }
    .form-control {
    background: none;
    border: none;
    color: #ffffff;
    padding:8px 45px;
    line-height: 1;
    height: auto;
    font-size: 16px;
    outline:none;
    box-shadow:none;
    &::-moz-placeholder{color:rgba(255, 255, 255,  0.6);}
    &::-webkit-input-placeholder{color:rgba(255, 255, 255,  0.6);}
    &:focus::-webkit-input-placeholder{font-size:0;}
    &:focus::-moz-placeholder{font-size:0;}
    }
    .x-alt.search_disabled_btn{display:block;}
    }
    &.search_enabled,
    &.searching_enabled {
    background: rgba(255, 255, 255, 0.1);
    .search_for_new_chat_inner {
    background: none;
    .search{display:none;}
    .back{display:block;}
    }
    }
    }
    .msg_forward_btn_wrp {
        background: #87cefa;
        color: #000;
        padding: 5px 15px;    
        border-radius: 0px 0px 5px 5px;
        // position: absolute;
        width:100%;
        // bottom: 0;
        .msg_forward_to_selcted_wrp {
            padding: 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            // width: 85%;
            margin:0px;
            li{
                font-size:16px;margin-right:5px;
                &:last-child i {display:none;}
                display:inline-block;
            }
        }
        .btn{
            padding: 0 0 0 2px;
            outline: none;
            -webkit-box-shadow: 0 1px 3px rgba(11,20,26, .4);
            box-shadow: 0 1px 3px rgba(11,20,26, .4);
            background: #000;
            border-radius: 50%;
            height: 40px;
            width: 40px;
            text-align: center;
            line-height: 20px;
            &:hover{background:#ffe400; svg path{fill:#000000;}}
        }
    }
    .forward_popup_body{position: relative;}
}
</style>